var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHamburger = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "nav-hamburger"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Hamburger",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5 4H1.5C1.224 4 1 4.224 1 4.5C1 4.776 1.224 5 1.5 5H20.5C20.776 5 21 4.776 21 4.5C21 4.224 20.776 4 20.5 4ZM20.5 10.25H1.5C1.224 10.25 1 10.474 1 10.75C1 11.026 1.224 11.25 1.5 11.25H20.5C20.776 11.25 21 11.026 21 10.75C21 10.474 20.776 10.25 20.5 10.25ZM1.5 17H20.5C20.776 17 21 17.224 21 17.5C21 17.776 20.776 18 20.5 18H1.5C1.224 18 1 17.776 1 17.5C1 17.224 1.224 17 1.5 17Z",
    fill: "white"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHamburger);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/hamburger.db4f805052a74bbd79d5d0e8419d4142.svg";